import { render } from "./News.vue?vue&type=template&id=25063885&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=25063885&scoped=true&lang=css"
import "./News.vue?vue&type=style&index=1&id=25063885&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25063885"],['__file',"src/views/news/News.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25063885"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25063885', __exports__)) {
    api.reload('25063885', __exports__)
  }
  
  module.hot.accept("./News.vue?vue&type=template&id=25063885&scoped=true", () => {
    api.rerender('25063885', render)
  })

}


export default __exports__